import { IconType } from "../../../common/components/icon/IconType";
import { Permission, userHasAnyPermission, userHasPermission } from "../../../utils/permissions";
import { userIsLoggedIn, userIsRegistered } from "../../../utils/roles";
import { useSelector } from "react-redux";
import { selectWishlistAmount } from "../../../Wishlist/redux/wishlistSelectors";
import { useSimpleMenuState } from "../../../common/components/Menu/Menu";
import { REMOVE_SALES_PARTNER_FINDER } from "../../../utils/constants";
import { STORE_FINDER } from "../../../utils/url/staticUrls";
import { getWishlistNavigationEntryUrl, useLoadWishlistsOnMount } from "../../../Wishlist/wishlistHelper";
import { selectProductComparisonList } from "../../../ProductComparison/redux/productComparisonSelectors";
import { getProductComparisonNavigationEntryUrl } from "../../../ProductComparison/productComparisonHelper";
import { NotificationNavItem } from "~/Header/components/Notifications/NotificationNavItem";
import { useTranslation } from "react-i18next";
import { canSeeWishlistButton } from "~/utils/features";
import { HeaderMinicart } from "~/feature/cart/cart/components/Minicart/MinicartComponent";
import { NavItems } from "~/Header/components/headerMenu/PersonalNavItems";
import { PersonalNavItem } from "~/Header/components/headerMenu/PersonalNavItem";

const WISHLIST_URL = getWishlistNavigationEntryUrl();
const PRODUCT_COMPARISON_URL = getProductComparisonNavigationEntryUrl();

export const canSeeSalesFinder = () => !REMOVE_SALES_PARTNER_FINDER && (!userIsLoggedIn() || userIsRegistered());
export const canSeeFCC = () => userHasPermission(Permission.CanOpenFCC);

export const canSeeMyCompany = userHasAnyPermission(
  Permission.SEE_ABMONITOR,
  Permission.SEARCH_ORDERS,
  Permission.SEARCH_QUOTES,
  Permission.BULK_UPLOAD,
  Permission.VIEW_CONTRACT,
);

const DesktopPersonalNav = () => {
  const { t } = useTranslation();
  const canSeeCart = userHasAnyPermission(Permission.ADD_TO_CART, Permission.ADD_TO_QUOTE);

  const showWishlistMenuEntry = canSeeWishlistButton();

  const [isOpen, handleClick, handleClose, anchorEl] = useSimpleMenuState();

  const listItems = useSelector(selectProductComparisonList).length;

  useLoadWishlistsOnMount();

  const wishlistAmount = useSelector(selectWishlistAmount);

  return (
    <div className="scha__personal-nav">
      <ul className="scha__personal-nav__list">
        {canSeeFCC() && (
          <li className="scha__personal-nav__list__item">
            <NavItems.FCC />
          </li>
        )}
        {canSeeSalesFinder() && (
          <li className="scha__personal-nav__list__item">
            <a href={STORE_FINDER} data-test-id={"header-sales-partner"}>
              <PersonalNavItem
                data-test-id={"header-btn-sales-partner"}
                icon={IconType.Location}
                name={t("salesPartner.title")}
              />
            </a>
          </li>
        )}
        {canSeeMyCompany && (
          <li className="scha__personal-nav__list__item">
            <NavItems.MyCompany />
          </li>
        )}
        <NotificationNavItem />
        <li className="scha__personal-nav__list__item">
          <a href={PRODUCT_COMPARISON_URL} id="home_comparison_list_btn" data-test-id={"header-wishlist"}>
            <PersonalNavItem
              icon={IconType.Checklist}
              badgeContent={listItems}
              name={t("header.link.comparison.list")}
            />
          </a>
        </li>
        {showWishlistMenuEntry && (
          <li className="scha__personal-nav__list__item">
            <a href={WISHLIST_URL} id="home_wishlist_btn" data-test-id={"header-wishlist"}>
              <PersonalNavItem
                name={t("wishlistPage.title")}
                icon={IconType.Bookmark}
                data-test-id={"header-btn-wishlist"}
                badgeContent={wishlistAmount !== undefined ? wishlistAmount : ""}
              />
            </a>
          </li>
        )}
        {canSeeCart && (
          <li className="scha__personal-nav__list__item">
            <HeaderMinicart className={"scha__personal-nav__list__item__cart"} />
          </li>
        )}
      </ul>
    </div>
  );
};

export default DesktopPersonalNav;
